module.exports = __webpack_public_path__ + "static/media/Img-onboarding-tokens-03.c257cf8e.png";